import { isDebugDumpActive } from '@iconik-io/core/src/debug_logger/debug_logger';

import Button from '../../ui/button/button';

import styles from './debug_dump.module.css';

type Props = {
  label?: string;
  data: unknown;
};

function DebugDump({ label, data }: Props) {
  if (!isDebugDumpActive) {
    return null;
  }

  return (
    <div className={styles.root}>
      <Button
        className={styles.button}
        variant="info"
        wideBasis={false}
        noBorder
        size="s"
        onClick={(event) => {
          event.stopPropagation();
          const json = JSON.stringify(data, null, 4);
          const blob = new Blob([json], { type: 'application/json' });
          const url = URL.createObjectURL(blob);

          window.open(url, '_blank');

          // Clean up by revoking the blob URL after its use
          setTimeout(() => {
            URL.revokeObjectURL(url);
          }, 1000);
        }}
      >
        <span className={styles.label}>{label}</span>
      </Button>
      <div className={styles.triangle} />
    </div>
  );
}

export default DebugDump;
